import React from 'react'

import { Main, Nav, Footer } from '../components/layout'
import { Providers } from '../components/layout'
import About from '../components/views/about/About'
import useAboutPageData from '../cmsHooks/useAboutPageData'
import CMS from '@talus-analytics/library.airtable-cms'

const AboutPage = (): JSX.Element => {
  const data = useAboutPageData()

  return (
    <Providers>
      <CMS.SEO title={CMS.getText(data, 'Page title')} />
      <Nav />
      <Main>
        <About />
      </Main>
      <Footer />
    </Providers>
  )
}

export default AboutPage
